import {
  useState,
} from 'react';
import { t } from 'ttag';

import {
  SelectOption,
  SelectPaginated,
  SelectProps,
} from '@ui/Select';
import {
  DeliveryService,
  WarehouseType,
  WarehousePurpose,
} from '@newModels';

import { useDeliveryPointSelectQuery } from './queries/graphql.v4.generated';

export type DeliveryPointOption = SelectOption<string>;

type Props = {
  deliveryService: DeliveryService;
  cityId: string;
  warehouseType?: WarehouseType;
  placeholder?: string;
  purpose: WarehousePurpose;
} & Omit<SelectProps<DeliveryPointOption>, 'options'>;

export const DeliveryPointSelectContainer: React.FC<Props> = ({
  deliveryService,
  cityId,
  isDisabled,
  warehouseType,
  purpose,
  placeholder = t`Виберіть відділення`,
  ...props
}) => {
  const { value } = props;
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const { data, loading } = useDeliveryPointSelectQuery({
    variables: {
      deliveryService,
      cityId,
      purpose,
      type: warehouseType,
    },
    context: { v4: true },
    skip: isDisabled,
  });

  let options: readonly DeliveryPointOption[] = [];
  if (data && data.orderWarehouses) {
    options = data.orderWarehouses.map(
      (warehouse) => ({ value: warehouse.id, label: warehouse.name }),
    );
  }

  const onInputChange = (searchString: string) => {
    setInputValue(searchString);
  };

  return (
    <SelectPaginated
      {...props}
      isLoading={loading}
      isSearchable={true}
      placeholder={placeholder}
      options={options}
      blurInputOnSelect={true}
      inputValue={inputValue}
      menuIsOpen={menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      onFocus={() => setInputValue((value as DeliveryPointOption)?.label || '')}
      onInputChange={onInputChange}
      isClearable={true}
    />
  );
};
